<div class="full-width full-height">
  <mat-spinner class="progress" diameter="40" color="primary"></mat-spinner>
</div>
